/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API20970Item {
  
  /** 云分类id */
  cloudCategoryId?: string;
  
  /** 云分类名称 */
  cloudCategoryName?: string;
  
  /** 平台下的模块列表 ,QuickEntryModuleVO */
  moduleList?: API20970Item[];
  
};
    
  



  export type API20970Req = {};



export interface API20970Res {
  /** T  */
  list?: API20970Item[];
  
};


// 20970 显示待加入常用功能的菜单数据

export interface IUseGetAPI20970Return {
  /** 显示待加入常用功能的菜单数据: 接口请求状态 */
  isAPI20970Loading: boolean;
  /** 显示待加入常用功能的菜单数据: 接口请求返回数据 */
  dataAPI20970: API20970Res;
  /**  显示待加入常用功能的菜单数据: 接口数据请求方法 */
  fetchAPI20970Data:  ( config?: YWRequestConfig) => Promise<API20970Res>;
  /** 显示待加入常用功能的菜单数据: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI20970 = ():IUseGetAPI20970Return => {
  let isMount = true;
  const [isAPI20970Loading, setIsAPI20970Loading] = useState(false);
  const [dataAPI20970, setDataAPI20970] = useState<API20970Res>({} as API20970Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/home/common/entry/tree`;

  const fetchAPI20970Data = async ( config?: YWRequestConfig): Promise<API20970Res> => {
  
    if ( isMount ) {
      setIsAPI20970Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API20970Res>(`${basePath}/ywwl-admin/desktop/home/common/entry/tree`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI20970(res || {} as API20970Res);
        setIsAPI20970Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20970Loading(false);
      }
      return false as unknown as API20970Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20970Loading,
    dataAPI20970,
    fetchAPI20970Data,
    requestUrl,
  }
}

